import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  (window as any).deferredPrompt = e;
});

window.addEventListener('appinstalled', () => {
  (window as any).deferredPrompt = null;
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
